import React, { useState } from 'react';
import clsx from 'clsx';
import { useHistory, useLocation } from 'react-router';
import { useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import { useFormik } from 'formik';
// import Axios from 'axios-observable';
import * as Yup from 'yup';
import axios from 'axios';
// import Snackbar from '@material-ui/core/Snackbar';
// import Alert from '@material-ui/lab/Alert';
import RadioGroup from '@material-ui/core/RadioGroup';
import Radio from '@material-ui/core/Radio';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { Card, CardContent, Typography, Grid } from '@material-ui/core';
import Input from '@material-ui/core/Input';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import LoaderPopUp from '../../../components/loaderpopup/loader';
import SuccessPopUp from '../../../components/loaderpopup/success';
import ErrorPopUp from '../../../components/loaderpopup/error';
import ButtonComp from '../../../components/button/index';
import { CommonConfig } from '../../../config/common-config';
// import { Button, TextField } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    button: {
        textTransform: 'capitalize',
        padding: '8px 40px !important',
        letterSpacing: 'normal',
        background: '#3f51b5 !important',
        color: '#fff !important',
        borderRadius: '6px !important',
        border: 'none !important',
        cursor: 'pointer',
    },
    btnspace: {
        width: '100%',
    },
    disableBtn: {
        color: '#bbb !important',
        background: '#cecece !important',
        padding: '8px 40px !important',
        fontFamily: 'Rubik',
        textTransform: 'none !important',
        pointerEvents: 'none',
        borderRadius: '6px !important',
        border: 'none !important',
    },
    popTitle: {
        '& h2': {
            fontFamily: 'Rubik',
            fontSize: '18px',
            color: '#444',
        },
    },
    popContent: {
        fontFamily: 'Rubik',
        color: '#444',
    },
    popFoot: {
        fontFamily: 'Rubik',
        display: 'initial',
        paddingBottom: '20px',
        '& button': {
            marginLeft: '16px !important',
        },
    },
    remarks: {
        fontSize: '1rem',
        borderBottom: '1px solid #ccc',
    },
    btnBluepop: {
        fontSize: '14px !important',
        fontWeight: '400 !important',
        borderRadius: '6px',
        textTransform: 'capitalize',
        padding: '4px 20px',
        letterSpacing: 'normal',
        fontFamily: 'Rubik',
        background: '#3f51b5 !important',
        color: 'white',
    },
}));

function StyledRadio(props) {
    const classes = useStyles();

    return (
        <Radio
            className={classes.root}
            disableRipple
            color="default"
            checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
            icon={<span className={classes.icon} />}
            {...props}
        />
    );
}
export default function AdminEditBankDetails(props) {
    const location = useLocation();
    const history = useHistory();
    const classes = useStyles();

    const [showLoader, setShowLoader] = useState(false);
    const [allBankDetailsAdded, setAllBankDetailsAdded] = useState([]);
    const [updateStat, setUpdateStat] = useState(false);
    const bank = location.state.row;
    const tempValue = bank.hasOwnProperty('declarationvalue') ? bank.value : '';
    const [declarationValue, setDeclarationValue] = useState(tempValue);
    const [declarationList, setDeclarationList] = useState('');
    const [selectedImc, setselectedImc] = useState('');
    // const imcClientName = location.imcClient.editpageName;

    // For Implementating tennantName
    const tennantName = useSelector((state) => state.loginsuccessreducer.tennantName);
    const tennantname = tennantName && tennantName.tennantName;
    const [successpop, setSuccessPop] = useState(false);
    const [errorpop, setErrorPop] = useState(false);
    const [errorMsgGenerateRecceipt, setErrorMsgGenerateRecceipt] = useState('');

    // For Implementating JWT-Token
    const tempToken = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails.result);
    const userToken = tempToken && tempToken.data.token;
    const bearerToken = `Bearer ${userToken}`;
    const JwtToken = {
        headers: {
            Authorization: bearerToken,
        },
    };

    const handleClose = () => {
        setShowLoader(false);
    };
    const formik = useFormik({
        initialValues: {
            accountholdername: bank.accountholderName,
            accountnumber: bank.accountNumber,
            bankname: bank.bankName,
            branch: bank.branch,
            ifsccode: bank.ifscCode,
            isPrimaryAccount: '',
            isTaxPayment: '',
        },
        validationSchema: Yup.object().shape({
            accountholdername: Yup.string()
                // .matches(/^[A-Z]{1}[A-Za-z ]+$/, 'First letter should be in capital')
                // .matches(/^((?![0-9]).)*$/, 'Enter Valid AccountHolderName')
                .required('Required Field'),
            bankname: Yup.string()
                .matches(/^[aA-zZ ]+$/, 'Enter Valid Bank Name')
                .required('Required Field'),
            branch: Yup.string()
                // .matches(/^[aA-zZ ]+$/, 'Enter Valid Branch Name')
                .required('Required Field'),
            accountnumber: Yup.string()
                .matches(/^\d{9,18}$/, 'Enter Valid Account Number')
                .required('Account Number is Mandatory'),
            ifsccode: Yup.string()
                .matches(/^[A-Z]{4}[0][0-9A-Z]{6}$/, 'Enter Valid IFSC Code')
                .required('Enter IFSC code'),
            isPrimaryAccount: Yup.string(),
            isTaxPayment: Yup.string(),
        }),
        onSubmit: (values) => {
            setShowLoader(true);
            const data = {
                accountholderName: values.accountholdername,
                accountNumber: values.accountnumber,
                bankName: values.bankname,
                branch: values.branch,
                ifscCode: values.ifsccode,
                isDefault: values.isPrimaryAccount || bank.isDefault ? true : false,
                createdBy: bank.createdBy,
                dateCreated: bank.dateCreated,
                dateModified: bank.dateModified,
                isActive: bank.isActive,
                modifiedBy: bank.modifiedBy,
                isSettax: values.isTaxPayment === 'true' || bank.isSettax ? true : false,
                id: bank.id,
            };

            axios
                .put(`${CommonConfig.dev.baseUrl}/api/auth/bankdetails/${tennantname}`, data, JwtToken)
                .then((response) => {
                    setShowLoader(false);
                    setSuccessPop(true);
                    setAllBankDetailsAdded(response.data);
                    setTimeout(() => {
                        history.push({
                            pathname: '/menu/adminbankdetails',
                            allBankDetailsAdded,
                        });
                    }, 3000);
                })
                .catch((error) => {
                    //console.log('error', error.response.data);
                    const errResult = error.response;
                    if (errResult && errResult.data) {
                        setShowLoader(false);
                        setErrorPop(true);
                        setTimeout(() => {
                            setErrorPop(false);
                        }, 5000);
                        setErrorMsgGenerateRecceipt(errResult.data.message);
                        // formik.resetForm({ values: '' });
                    }
                });
        },
    });

    const handleSubmitDeclaration = () => {
        //console.log('declaraion', declarationValue)
        setDeclarationList(declarationValue);
        let temp = {
            declaration: declarationValue,
            declarationId: 1,
        };
        axios
            .put(`${CommonConfig.dev.baseUrl}/api/auth/declaration/${tennantname}/1`, temp, JwtToken)
            .then((response) => {
                setShowLoader(false);
                // setSuccessPop(true);
                setTimeout(() => {
                    history.push({
                        pathname: '/menu/adminbankdetails',
                    });
                }, 3000);
            })
            .catch((error) => {
                //console.log('error', error.response.data);
                const errResult = error.response;
                if (errResult.data) {
                    setShowLoader(false);
                    setErrorPop(true);
                    setTimeout(() => {
                        setErrorPop(false);
                    }, 5000);
                    // formik.resetForm({ values: '' });
                }
            });
    };

    const navigateBack = () => {
        history.push({
            pathname: '/menu/adminbankdetails',
        });
    };
    const toInputUppercase = (e) => {
        e.target.value = ('' + e.target.value).toUpperCase();
    };

    return (
        <>
            {/* <Snackbar
                className="deleteError"
                open={updateStat}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                autoHideDuration={3000}
                onClose={() => {
                    setUpdateStat(false);
                }}
            >
                <Alert
                    onClose={() => {
                        setUpdateStat(false);
                    }}
                >
                    Bank Details updated successfully
                </Alert>
            </Snackbar> */}

            {successpop ? (
                <SuccessPopUp
                    open={successpop}
                    showSuccess={successpop}
                    handleClose={handleClose}
                    title="Bank Details updated successfully"
                />
            ) : null}
            {errorpop ? (
                <ErrorPopUp open={errorpop} showError={errorpop} handleClose={handleClose} title={errorMsgGenerateRecceipt} />
            ) : null}

            <form className="itecform" onSubmit={formik.handleSubmit}>
                <Card className="client-card">
                    <CardContent className="client-heading">
                        <Typography variant="h5">Update Bank Details</Typography>
                    </CardContent>
                    <CardContent>
                        <Grid container spacing={3} className="main-container">
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <InputLabel className="lbl" htmlFor="accountholdername" shrink>
                                        Account holder name
                                    </InputLabel>
                                    <Input
                                        type="text"
                                        className="bottom"
                                        placeholder="Account holder name"
                                        name="accountholdername"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.accountholdername}
                                    />
                                    {formik.touched.accountholdername && formik.errors.accountholdername ? (
                                        <span className="itec-validationError">{formik.errors.accountholdername}</span>
                                    ) : null}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <InputLabel className="lbl" htmlFor="accountnumber" shrink>
                                        Account number
                                    </InputLabel>
                                    <Input
                                        type="text"
                                        className="bottom"
                                        placeholder="Account number"
                                        name="accountnumber"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.accountnumber}
                                    />
                                    {formik.touched.accountnumber && formik.errors.accountnumber ? (
                                        <span className="itec-validationError">{formik.errors.accountnumber}</span>
                                    ) : null}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <InputLabel className="lbl" htmlFor="bankname" shrink>
                                        Bank name
                                    </InputLabel>
                                    <Input
                                        type="text"
                                        className="bottom"
                                        placeholder="Bank name"
                                        name="bankname"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.bankname}
                                    />
                                    {formik.touched.bankname && formik.errors.bankname ? (
                                        <span className="itec-validationError">{formik.errors.bankname}</span>
                                    ) : null}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <InputLabel className="lbl" htmlFor="branch" shrink>
                                        Branch
                                    </InputLabel>
                                    <Input
                                        type="text"
                                        className="bottom"
                                        placeholder="Branch"
                                        name="branch"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.branch}
                                    />
                                    {formik.touched.branch && formik.errors.branch ? (
                                        <span className="itec-validationError">{formik.errors.branch}</span>
                                    ) : null}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <InputLabel className="lbl" htmlFor="ifsccode" shrink>
                                        IFSC Code
                                    </InputLabel>
                                    <Input
                                        onInput={toInputUppercase}
                                        type="text"
                                        className="bottom"
                                        placeholder="IFSC Code"
                                        name="ifsccode"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.ifsccode}
                                    />
                                    {formik.touched.ifsccode && formik.errors.ifsccode ? (
                                        <span className="itec-validationError">{formik.errors.ifsccode}</span>
                                    ) : null}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={3}>
                                {bank.isDefault ? (
                                    <div className="defaultTrueDiv">
                                        <ul style={{ listStyle: 'none', paddingLeft: '0px', display: 'flex' }}>
                                            <li style={{ alignItems: 'center' }}>
                                                <i className="primarybank-btnIcon">
                                                    <FontAwesomeIcon icon={faCheck} />
                                                </i>
                                            </li>
                                            <li>
                                                <label className="lbl">Set as bank account to receive fees</label>
                                            </li>
                                        </ul>
                                    </div>
                                ) : (
                                        <FormControl component="fieldset">
                                            <RadioGroup name="customized-radios" className="radio-option">
                                                <ul style={{ listStyle: 'none', paddingLeft: '10px' }}>
                                                    <li>
                                                        <FormControlLabel
                                                            value="true"
                                                            name="isPrimaryAccount"
                                                            control={<StyledRadio />}
                                                            label="Set as bank account to receive fees"
                                                            onChange={formik.handleChange}
                                                            // onClick={() => handleClick(formik.values.isPrimaryAccount)}
                                                            defaultChecked={formik.values.isPrimaryAccount === 'true'}
                                                        />
                                                    </li>
                                                </ul>
                                            </RadioGroup>
                                        </FormControl>
                                    )}
                            </Grid>
                            <Grid item xs={12} sm={3}>
                                {bank.isSettax ? (
                                    <div className="defaultTrueDiv">
                                        <ul style={{ listStyle: 'none', paddingLeft: '10px', display: 'flex' }}>
                                            <li style={{ alignItems: 'center' }}>
                                                <i className="primarybank-btnIcon">
                                                    <FontAwesomeIcon icon={faCheck} />
                                                </i>
                                            </li>
                                            <li>
                                                <label className="lbl">Set as bank account to receive client tax payments</label>
                                            </li>
                                        </ul>
                                    </div>
                                ) : (
                                        <FormControl component="fieldset">
                                            <RadioGroup name="customized-radios" className="radio-option">
                                                <ul style={{ listStyle: 'none', paddingLeft: '10px' }}>
                                                    <li>
                                                        <FormControlLabel
                                                            value="true"
                                                            name="isTaxPayment"
                                                            control={<StyledRadio />}
                                                            label="Set as bank account to receive client tax payments"
                                                            onChange={formik.handleChange}
                                                            defaultChecked={formik.values.isTaxPayment === 'true'}
                                                        />
                                                    </li>
                                                </ul>
                                            </RadioGroup>
                                        </FormControl>
                                    )}
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
                <div style={{ display: 'flex' }}>
                    <div>
                        <button color="primary" className="intermediarybutn" onClick={navigateBack}>
                            Back
                        </button>
                    </div>
                    <div style={{ marginTop: '-18px', marginLeft: '12px' }}>
                        {(showLoader ? (
                            <LoaderPopUp
                                showLoader={showLoader}
                                title="Please wait while we update your Request"
                                handleClose={handleClose}
                            />
                        ) : null) || <ButtonComp type="submit" className="intermediarybutn" title="Update Bank" />}
                    </div>
                </div>
            </form>

            {/* {bank.hasOwnProperty('declarationtype') ?
                <div style={{ paddingTop: '20px' }}>
                    <Card className="client-card">
                        <CardContent className="client-heading">
                            <Typography variant="h5">Update Declaration for Invoice generation</Typography>
                        </CardContent>

                        <CardContent>
                            <Grid container spacing={3} className="main-container">

                                <Grid item xs={12} sm={12}>
                                    <FormControl fullWidth>
                                        <InputLabel className="lbl" htmlFor="tennantName" shrink>
                                            Declaration
                                        </InputLabel>
                                        <TextField
                                            type="text"
                                            placeholder="Enter the Declaration"
                                            className="bottom marginTop"
                                            name="declaration"
                                            multiline
                                            rows={4}
                                            onChange={(e) => setDeclarationValue(e.target.value)}
                                            // onBlur={formik.handleBlur}
                                            value={declarationValue}
                                        />
                                    </FormControl>
                                </Grid>
                            </Grid>
                        </CardContent>
                    </Card>
                    <Button variant="outlined" color="primary" className={declarationValue ? classes.button : classes.disableBtn}
                        onClick={handleSubmitDeclaration}>
                        Update
                    </Button>
                </div> : null} */}
        </>
    );
}
